import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePatientInsuranceDetailsMutationVariables = Types.Exact<{
  input: Types.UpdatePatientInsuranceDetailsInput;
  canUpdateAcrossWholeTerritory?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdatePatientInsuranceDetailsMutation = { readonly __typename?: 'Mutation', readonly updatePatientInsuranceDetails: { readonly __typename?: 'Patient', readonly uuid: string, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly paymentUpToDate?: boolean | null, readonly expiryDate?: string | null, readonly visitValidation?: { readonly __typename?: 'PatientInsuranceVisitValidation', readonly expiryStrategy?: string | null } | null, readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } | null } };


export const UpdatePatientInsuranceDetailsDocument = gql`
    mutation updatePatientInsuranceDetails($input: UpdatePatientInsuranceDetailsInput!, $canUpdateAcrossWholeTerritory: Boolean) {
  updatePatientInsuranceDetails(
    input: $input
    canUpdateAcrossWholeTerritory: $canUpdateAcrossWholeTerritory
  ) {
    uuid
    insurance {
      insuranceType
      insuranceNumber
      paymentUpToDate
      expiryDate
      visitValidation {
        expiryStrategy
      }
      insuranceProvider {
        name
        visitValidation {
          expiryStrategy
        }
      }
    }
  }
}
    `;
export type UpdatePatientInsuranceDetailsMutationFn = Apollo.MutationFunction<UpdatePatientInsuranceDetailsMutation, UpdatePatientInsuranceDetailsMutationVariables>;

/**
 * __useUpdatePatientInsuranceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientInsuranceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientInsuranceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientInsuranceDetailsMutation, { data, loading, error }] = useUpdatePatientInsuranceDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      canUpdateAcrossWholeTerritory: // value for 'canUpdateAcrossWholeTerritory'
 *   },
 * });
 */
export function useUpdatePatientInsuranceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientInsuranceDetailsMutation, UpdatePatientInsuranceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientInsuranceDetailsMutation, UpdatePatientInsuranceDetailsMutationVariables>(UpdatePatientInsuranceDetailsDocument, options);
      }
export type UpdatePatientInsuranceDetailsMutationHookResult = ReturnType<typeof useUpdatePatientInsuranceDetailsMutation>;
export type UpdatePatientInsuranceDetailsMutationResult = Apollo.MutationResult<UpdatePatientInsuranceDetailsMutation>;
export type UpdatePatientInsuranceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePatientInsuranceDetailsMutation, UpdatePatientInsuranceDetailsMutationVariables>;